import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectCurrentUser } from 'modules/authentication/state/selectors';
import {
  selectClockedInActionResult,
  selectTimeclockJobPositions,
  selectTimeclockJobPositionsLoading,
} from 'modules/timeclock/state/selectors';
import useRootSelector from 'common/hooks/useRootSelector';
import TimeClockSideMenu from 'modules/timeclock/containers/TimeclockSideMenu/TimeClockSideMenu';
import TimeClockJobPositionList from '../TimeclockJobPositionList/TimeclockJobPositionList';
import {
  clockInEmployeePositionAction,
  getEmployeeTimeclockJobPositions,
} from 'modules/timeclock/state/actions';
import { ITimeClockEmployeeJobPosition } from 'common/interfaces/employee';
import { IUserProfileInfoImt } from 'modules/authentication/interfaces';
import { ActionResult } from 'common/constants';
import messages from 'modules/timeclock/messages';

interface IClockInModal {
  anchorEl: null | Element;
  onClose: () => void;
}

const ClockInModal: FC<IClockInModal> = ({ anchorEl, onClose }) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const currentUser: IUserProfileInfoImt = useRootSelector(selectCurrentUser);
  const jobPositions: ITimeClockEmployeeJobPosition[] = useRootSelector(
    selectTimeclockJobPositions,
  );
  const jobPositionsLoading: boolean = useRootSelector(selectTimeclockJobPositionsLoading);
  const clockedInResult: ActionResult = useRootSelector(selectClockedInActionResult);

  useEffect(() => {
    dispatch(getEmployeeTimeclockJobPositions(currentUser?.get('id')));
  }, [dispatch, currentUser]);

  useEffect(() => {
    if (clockedInResult === ActionResult.SUCCESS_ACTION) {
      dispatch(clockInEmployeePositionAction(null));
      dispatch(getEmployeeTimeclockJobPositions(currentUser?.get('id')));
    }
  }, [dispatch, currentUser, clockedInResult]);

  return (
    <TimeClockSideMenu
      anchorEl={anchorEl}
      onClose={onClose}
      title={intl.formatMessage(messages.myTimeclockLabel)}
      isLoading={jobPositionsLoading}
    >
      <TimeClockJobPositionList
        jobPositions={jobPositions}
        employeeId={currentUser?.get('id')}
        isProfile
      />
    </TimeClockSideMenu>
  );
};

export default ClockInModal;
